module.exports = __webpack_public_path__ + "img/notification_important.c42b3caf.svg";